import { apiVerifyEmail, apiCheckTenantStatus, apiRetryCheckTenant } from '../../apis/registration'
import { env } from '../../constants'

export function requestVerifyEmail(token) {
  if (env.USE_MOCK) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          reg_token: 'reg_token',
          workspace_url: 'workspace_url_foobar@workspace_url.com',
          username: 'demo',
          email: 'email',
        })
      }, 1000)
    })
  }

  return apiVerifyEmail.request(token)
}

export function requestCheckTenantStatus(token) {
  if (env.USE_MOCK) {
    // mock
    // 可以通过修改 status 进入不同场景
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 99,
          tenant_active_url: 'tenant_active_url',
          message: 'error',
        })
      }, 1000)
    })
  }

  return apiCheckTenantStatus.request(token)
}

export function requestRetryCheckTenant(token) {
  return apiRetryCheckTenant.request(token)
}
